exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-checkbox[data-v-1e942090] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n", ""]);

// exports
